import { Helmet } from 'react-helmet-async';
import { PageLayout } from '../components/layout/PageLayout';
import { Hero } from '../components/landing/Hero';
import { FeaturesSection } from '../components/landing/FeaturesSection';
import { HowItWorks } from '../components/landing/HowItWorks';
import { CTASection } from '../components/landing/CTASection';

export const HomePage = () => {
  return (
    <PageLayout>
      <Helmet>
        <title>Solo Sense — Spatial Transcription for Apple Vision Pro</title>
        <meta name="description" content="Transform spoken audio into beautiful, spatial captions that float right in front of you. Real-time transcription designed for Apple Vision Pro." />
        <link rel="canonical" href="https://solosense.ai/" />
      </Helmet>
      <Hero />
      <FeaturesSection />
      <HowItWorks />
      <CTASection />
    </PageLayout>
  );
};
